export default __webpack_public_path__ + "static/media/stay-safe.1c044be4.svg";